import { render, staticRenderFns } from "./BarCardTab.vue?vue&type=template&id=346940dc&scoped=true"
import script from "./BarCardTab.vue?vue&type=script&lang=js"
export * from "./BarCardTab.vue?vue&type=script&lang=js"
import style0 from "./BarCardTab.vue?vue&type=style&index=0&id=346940dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346940dc",
  null
  
)

export default component.exports